// extracted by mini-css-extract-plugin
module.exports = {"body_dashboard":"styles_body_dashboard__1Ll7B","body_dashboard__loading":"styles_body_dashboard__loading__1Z4cm"};